<template>
  <section class="main_slider">
    <div class="container grid-xl">
      <div class="columns">
        <div class="column col-xl-12 gl">
          <vue-glide 
            type="carousel"
            ref="slider" 
            :perView="1" 
            :gap="5" 
            :animationDuration="800" 
            :autoplay="false"
            animationTimingFunc="ease-in-out" 
            @glide:run-before="resetInfoBox" 
            @glide:run-after="animateSliderInfo">
            <vue-glide-slide v-for="slide in images" :key="slide.id">
              <div class="outer">
                <div class="img_cnt">
                  <img :src="slide.url" :alt="slide.name" class="img_cnt__img">
                </div>
              </div>
              <div class="slide_info border_r">
                <div class="slide_info__inner border_r">
                  <div class="info_text">
                    <h3>{{slide.name}}</h3>
                    <div v-if="slide.description" class="info_text__description">
                      {{slide.description}}
                    </div>
                  </div>
                  <sButton v-on:action="scrollToSection(slide.scrollTarget)"/>
                  <div class="bottom_overlay">
                    asd
                  </div>
                </div>
              </div>
            </vue-glide-slide>
            <template slot="control">
              <button @click="animateSlideControlls" class="mr-2 slider_btn btn" data-glide-dir="<">
                <chevronLeft :width="40"/>
              </button>
              <button @click="animateSlideControlls" class="ml-2 slider_btn btn" data-glide-dir=">">
                <chevronRight :width="40"/>
              </button>
            </template>
          </vue-glide>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import chevronRight from './svg_icons/chevronRight.vue';
import chevronLeft from './svg_icons/chevronLeft.vue';
import sButton from './sButton.vue';

export default {
  name: 'MainSlider',
  components: {
    chevronRight,
    chevronLeft,
    sButton
  },
  mounted(){
    this.animateSliderInfo()
  },
  data(){
    return{
      images: [
        {
          id: 1,
          url : require('../assets/images/main_slider/1.png'),
          name : 'Lorem ipsum dolor sit amet',
          scrollTarget : '.first_section',
          description: 'Non enim praesent elementum facilisis. Nisi vitae suscipit tellus mauris a diam maecenas sed. Eget egestas purus viverra accumsan. Arcu cursus vitae congue mauris rhoncus aenean vel elit. Tincidunt arcu non'
        },
        {
          id: 2,
          url : require('../assets/images/main_slider/2.png'),
          name : 'About',
          scrollTarget : '.second_section',
          description: 'Pellentesque habitant morbi tristique senectus et netus. Nunc sed velit dignissim sodales ut eu sem integer vitae. Lacus vestibulum sed arcu non. Non curabitur gravida arcu ac tortor dignissim'
        },
        {
          id: 3,
          url : require('../assets/images/main_slider/5.png'),
          name : 'Projects',
          scrollTarget : '.third_section',
          description: 'Eget mauris pharetra et ultrices neque ornare. Quam vulputate dignissim suspendisse in est ante in nibh mauris. Elit duis tristique sollicitudin nibh sit'
        }
      ],
      tween: null
    }
  },
  methods:{
    animateSliderInfo(){
      let infoBox = document.querySelector('.glide__slide--active .slide_info')
      this.tween = new TimelineLite()
        .to(infoBox, 0.4, {css:{ right: '0px'}, ease: Power1.easeInOut}) 
        .to(infoBox, 0.3, {css:{ opacity: 1}, ease: Power1.easeInOut},'-=0.2') 
    },
    resetInfoBox(){
      this.tween.reverse()
    },
    animateSlideControlls(e){
      let button = document.querySelector('.slider_btn')
      this.controllsTween = new TimelineLite()
        .to(e.target.closest("button.slider_btn"), 0.2, {css: { backgroundColor: '#41354d', scale: '1.1', boxShadow: '0 0 0 3px rgba(0,0,0,0.5)'}, ease: Power2.easeOut})
        .to(e.target.closest("button.slider_btn"), 0.1, {css: { backgroundColor: '#00BED0', scale: '1', boxShadow: '0 0 0 0 rgba(0,0,0,0.5)'}, ease: Power2.easeOut})
    },
    scrollToSection(element){
      if(element === '.second_section') this.$router.push({ path: 'about' })
      if(element === '.third_section') this.$router.push({ path: 'projects'})
      let el = document.querySelector(element)
      let scrollMinTime = Math.floor(el.offsetTop / 100) / 10
      let scrollTime = Math.max(scrollMinTime, 1)
      TweenLite.to(window, scrollTime, {scrollTo: element, ease: Power3.easeOut});
    }
  }
}
</script>

<style lang="scss">
.main_slider{
  min-height: calc( 100vh - (143px + 128px) );
  padding-bottom: 101px;
  background: url(../assets/images/main-slider-bg.svg) no-repeat;
  background-position: left bottom;
}
.main_slider{
  .glide{
    &__slides{
      margin-top: 0;
      margin-bottom: 0;
      .outer{
        max-width: 550px;
        width: 100%;
        margin-top: 2.5rem;
        margin-bottom: 6rem;
      }
      .img_cnt{
        position: relative;
        height: 0;
        padding-bottom: 76.36363636363636%;
        &__img{
          position: absolute;
          transition: all 0.3s linear;
        }
      }
    }
  }
  .glide__slide{
    position: relative;
    transition: all 0.2s linear;
  }
  .slider_btn{
    border: none;
    background-color: $pale-blue;
    padding: 0;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    -webkit-appearance: none;
    cursor: pointer;
    &.btn>svg{
      color: white;
    }
    >.icon{
      vertical-align: middle;
    }
    &:active{
      outline: 0;
      border: none;
    }
    &:focus{
      outline: 0;
      border: none;
    }
  }
  .slide_info{
    background-color: $dirty-vel;
    position: absolute;
    right: -120px;
    bottom: 0;
    width: 300px;
    min-height: 360px;
    opacity: 0;
    color: $gray-100;
    &__inner{
      overflow: hidden;
      position: relative;
      height: 100%;
      >.info_text{
        width: 100%;
        min-height: 360px;
        max-height: 100%;
        display: inline-block;
        padding: 1rem;
        text-align: justify;
      }
      a.btn{
        padding: 5px;
        background-color: white;
        position: absolute;
        bottom: 1rem;
        right: 1rem;
        z-index: 10;
        color: $gray-400;
        &:hover ~ .bottom_overlay{
          bottom: -19%;
          transform: rotate(-5deg);
        }
      }
      .bottom_overlay{
        transition: all 0.3s ease-in-out;
        position: absolute;
        bottom: -48%;
        left: -10%;
        height: 50%;
        width: 120%;
        background-color: $pale-blue;
      }
    }
  }
}
@media screen and (min-width: 961px) and (max-width: 1367px){
  .gl{
    padding: 0 3rem;
  }
}
@media (orientation: portrait) {
  .main_slider{
    min-height: initial;
    .glide{
      &__slides{
        .outer{
          margin-bottom: 13rem;
        }
      }
      .slider_btn{
        margin-top: 1.5rem;
      }
    }
  }
}
@media screen and (max-width: 550px) {
  .main_slider .slide_info{
    width: 240px;
    font-size: 0.9em;
  }
}
</style>